module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-white.7ceab1a9.png";